/**
 * Created by mukund on 12/20/17.
 */

angular.module('mediacloudApp')
    .directive('recordMetadata', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/metadata/metadata.html',
            scope: {
                showCancelDialog: '=',
                cancelRecording: '&'
            },
            link: function(scope, elem, atts){

            }
        }
    }]);
